<template>
    <div>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    md="6"
                    lg="4"
                    xl="3"
                    v-for="teacher in teachers"
                    :key="teacher.src"
                >
                    <v-card
                        class="soli-round"
                        style="border: none"
                        :ripple="false"
                        :disabled="teacher.disabled"
                    >
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: ["successMessage", "errors", "teachers"],
    data() {
        return {};
    },
    methods: {},
};
</script>
